import * as appHelper from './appHelper';
import * as dataHelpers from './dataHelper';
import * as objectConstants from '../constants/objectConstants';

export function setSuspendData(userData) {
    return new Promise((resolve, reject) => {

        let suspend_data = {
            lang: userData.lang,
            [appHelper.getShortHandKeyByRef("resources").key]: setResourcesSuspendData(userData.resources),
            [appHelper.getShortHandKeyByRef("bites").key]: setBiteSuspendData(userData.bites),
            [appHelper.getShortHandKeyByRef("attachments").key]: setAttachmentSuspendData(userData.attachments),
            [appHelper.getShortHandKeyByRef("short_response_questions").key]: setShortResponseSuspendData(userData.short_response_questions),
        };
        //console.log(JSON.stringify(suspend_data));
        resolve(suspend_data);
    });
}

function setAchievementSuspendData(achievements) {
    let achievementsSuspendData = [];
    for (let i = 0; i < achievements.length; i++) {
        let achievement = achievements[i];
        let achievementSuspendDataObj = Object.assign({}, {}, {
            [appHelper.getShortHandKeyByRef("code").key]: achievement.code,
            [appHelper.getShortHandKeyByRef("achieved").key]: achievement.achieved,
            [appHelper.getShortHandKeyByRef("achievedOn").key]: Object.assign([], achievement.achievedOn)
        });
        achievementsSuspendData = dataHelpers.immutablePush(achievementsSuspendData, achievementSuspendDataObj);
    }
    return achievementsSuspendData;

}

function setShortResponseSuspendData(short_response_questions) {

    let shortResponseQuestionArray = [];
    for (let i = 0; i < short_response_questions.length; i++) {
        let responseQuestion = Object.assign({}, short_response_questions[i]);
        let suspendDataResponseQuestion = {
            [appHelper.getShortHandKeyByRef("id").key]: responseQuestion.id,
            [appHelper.getShortHandKeyByRef("response").key]: responseQuestion.response,
        };
        if(responseQuestion.response.length > 0) {
            shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, suspendDataResponseQuestion);
        }
    }

    return shortResponseQuestionArray;
}

function setAttachmentSuspendData(attachments) {

    let attachmentsArray = [];
    for (let i = 0; i < attachments.length; i++) {
        let attachment = Object.assign({}, attachments[i]);
        let suspendDataAttachments = {
            [appHelper.getShortHandKeyByRef("id").key]: attachment.id,
            [appHelper.getShortHandKeyByRef("type").key]: appHelper.getShortHandKeyByRef(attachment.type).key,
            [appHelper.getShortHandKeyByRef("sub_type").key]: appHelper.isDefined(attachment.sub_type) ? appHelper.getShortHandKeyByRef(attachment.sub_type).key : "",
            [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(attachment.status).key,
        };
        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, suspendDataAttachments);
    }

    return attachmentsArray;
}

function setResourcesSuspendData(resources) {
    let resourcesScreenArray = [];

    for (let i = 0; i < resources.length; i++) {
        let resourcesScreen = resources[i];
        resourcesScreenArray = dataHelpers.immutablePush(resourcesScreenArray, setResourcesScreenResults(resourcesScreen));
    }
    return resourcesScreenArray;

}

function setResourcesScreenResults(resourcesScreen) {
    return {
        [appHelper.getShortHandKeyByRef("screen_id").key]: resourcesScreen.screen_id,
        [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(resourcesScreen.status).key,
        [appHelper.getShortHandKeyByRef("objects").key]: setResourceObjects(resourcesScreen.objects)
    };
}

function setResourceObjects(resourceObjects) {
    let resourceObjectArray = [];
    for (let i = 0; i < resourceObjects.length; i++) {
        let resourceObject = resourceObjects[i];
        if (resourceObject.status === objectConstants.STATUS_COMPLETE) {
            resourceObjectArray = dataHelpers.immutablePush(resourceObjectArray, setResourceObjectsResults(resourceObject));
        }
    }
    return resourceObjectArray;
}

function setResourceObjectsResults(resourceObject) {

    return {
        [appHelper.getShortHandKeyByRef("asset_id").key]: resourceObject.asset_id,
        [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(resourceObject.status).key,
    };
}

function setBiteSuspendData(bites) {
    let biteArray = [];
    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        biteArray = dataHelpers.immutablePush(biteArray, setBiteResult(bite));
    }
    return biteArray;
}

function setBiteResult(bite) {
    return {
        [appHelper.getShortHandKeyByRef("bite_id").key]: bite.bite_id,
        [appHelper.getShortHandKeyByRef("screens").key]: setBiteScreens(bite.screens),
        [appHelper.getShortHandKeyByRef("kpis").key]: setBiteKpis(bite.kpis),
        [appHelper.getShortHandKeyByRef("badges").key]: setBadgeSuspendData(bite.badges),
        [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(bite.status).key,
        [appHelper.getShortHandKeyByRef("required").key]: appHelper.getShortHandKeyByRef(bite.required).key,
        [appHelper.getShortHandKeyByRef("complete_target_screens").key]: setCompleteTargetScreens(bite.complete_target_screens),
        [appHelper.getShortHandKeyByRef("terminated").key]: appHelper.getShortHandKeyByRef(bite.terminated).key,

    };
}

function setCompleteTargetScreens(complete_target_screens){
    let completeTargetScreensSuspendData = [];
    for (let i = 0; i < complete_target_screens.length; i++) {

        let  target_screen = complete_target_screens[i];
        let targetScreenSuspendData = {
            [appHelper.getShortHandKeyByRef("screen_id").key]: target_screen.screen_id,
        };

        completeTargetScreensSuspendData = dataHelpers.immutablePush(completeTargetScreensSuspendData, targetScreenSuspendData);
    }

    return completeTargetScreensSuspendData;
}

function setBadgeSuspendData(badges) {
    let badgeSuspendData = [];
    for (let i = 0; i < badges.length; i++) {
        let badge = badges[i];
        let badgeSuspendDataObj = {
            [appHelper.getShortHandKeyByRef("badge_id").key]: badge.badge_id,
            [appHelper.getShortHandKeyByRef("achieved").key]: badge.achieved,
            [appHelper.getShortHandKeyByRef("achievedOn").key]: Object.assign([], badge.achievedOn)
        };
        badgeSuspendData = dataHelpers.immutablePush(badgeSuspendData, badgeSuspendDataObj);
    }
    return badgeSuspendData;

}

function setBiteKpis(kpis) {
    let kpisArray = [];
    for (let i = 0; i < kpis.length; i++) {
        let kpi = kpis[i];
        kpisArray = dataHelpers.immutablePush(kpisArray, setKpiResult(kpi));
    }

    return kpisArray;
}

function setKpiResult(kpi) {
    return {
        [appHelper.getShortHandKeyByRef("kpi_id").key]: kpi.kpi_id,
        [appHelper.getShortHandKeyByRef("current").key]: kpi.current,
        [appHelper.getShortHandKeyByRef("history").key]: setKpiHistory(kpi.history),
    };
}

function setKpiHistory(history) {
    let historyArray = [];
    for (let i = 0; i < history.length; i++) {
        let kpi = history[i];
        historyArray = dataHelpers.immutablePush(historyArray, setHistoryResult(kpi));
    }

    return historyArray;

}

function setHistoryResult(kpi) {
    return {
        [appHelper.getShortHandKeyByRef("hasValue").key]: kpi.hasValue ? 1 : 0,
        [appHelper.getShortHandKeyByRef("value").key]: kpi.value,
        [appHelper.getShortHandKeyByRef("asset_id").key]: kpi.asset_id,
        [appHelper.getShortHandKeyByRef("option_id").key]: kpi.option_id,
        [appHelper.getShortHandKeyByRef("current").key]: kpi.current,
        [appHelper.getShortHandKeyByRef("statusIndicatorClass").key]:{
            [appHelper.getShortHandKeyByRef("value").key]: kpi.statusIndicatorClass.value
        }
    };
}

function setBiteScreens(screens) {
    let screensArray = [];
    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        screensArray = dataHelpers.immutablePush(screensArray, setScreenResult(screen));
    }

    return screensArray;
}

function setScreenResult(screen) {
    //ONLY SHOW COMPLETE OBJECTS IF THE SCREEN IN PROGRESS SCREEN
    if (appHelper.isDefined(screen.objects) && screen.objects.length > 0) {
        let objectData = setScreensObjects(screen.objects, appHelper.getShortHandKeyByRef(screen.status).ref);
        //console.log(`screen`);
        //console.log(screen);
        //console.log(`objectData`);
        //console.log(objectData);
        if (objectData.length > 0) {
            return {
                [appHelper.getShortHandKeyByRef("screen_id").key]: screen.screen_id,
                [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(screen.status).key,
                [appHelper.getShortHandKeyByRef("objects").key]: objectData,
                [appHelper.getShortHandKeyByRef("required").key]: appHelper.getShortHandKeyByRef(screen.required).key,
            };
        } else {
            return {
                [appHelper.getShortHandKeyByRef("screen_id").key]: screen.screen_id,
                [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(screen.status).key,
                [appHelper.getShortHandKeyByRef("required").key]: appHelper.getShortHandKeyByRef(screen.required).key,
            };
        }


    } else if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
        return {
            [appHelper.getShortHandKeyByRef("screen_id").key]: screen.screen_id,
            [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(screen.status).key,
            [appHelper.getShortHandKeyByRef("required").key]: appHelper.getShortHandKeyByRef(screen.required).key,
            [appHelper.getShortHandKeyByRef("sub_screens").key]: setBiteScreens(screen.sub_screens),
        };
    } else {
        return {
            [appHelper.getShortHandKeyByRef("screen_id").key]: screen.screen_id,
            [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(screen.status).key,
            [appHelper.getShortHandKeyByRef("required").key]: appHelper.getShortHandKeyByRef(screen.required).key,
        };
    }
}

function setScreensObjects(objects, screen_status) {

    let objectArray = [];
    for (let i = 0; i < objects.length; i++) {
        let object = objects[i];

        if ((screen_status !== objectConstants.STATUS_COMPLETE && screen_status !== objectConstants.STATUS_NOT_STARTED) || appHelper.isDefined(object.options)) {
            if (appHelper.isDefined(object) && object.status === objectConstants.STATUS_COMPLETE) {
                //objectArray = dataHelpers.immutablePush(objectArray, object.object_id);
                objectArray = dataHelpers.immutablePush(objectArray, setObjectResult(object));
            }
        }
    }
    return objectArray;
}


function setObjectResult(object) {
    //console.log(`typeof object.options === ${typeof object.options} && typeof object.result === ${typeof object.result}`);
    if (appHelper.isDefined(object.options)) {
        return {
            [appHelper.getShortHandKeyByRef("asset_id").key]: object.asset_id,
            [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(object.status).key,
            //[appHelper.getShortHandKeyByRef("result").key]: appHelper.getShortHandKeyByRef(object.result).key,
            [appHelper.getShortHandKeyByRef("options").key]: object.options
        };
    } else {
        return {
            [appHelper.getShortHandKeyByRef("asset_id").key]: object.asset_id,
            [appHelper.getShortHandKeyByRef("status").key]: appHelper.getShortHandKeyByRef(object.status).key
        };
    }
    //return null;
}



/** WEBPACK FOOTER **
 ** ./src/helpers/suspendDataHelper.js
 **/